<template>
  <div class="post-form-media-image-item">
    <!-- <div v-if="media.image.ref">
      <v-icon>photo</v-icon> {{ media.image.ref }}
    </div>
    <div v-else>
      <v-icon>photo</v-icon>
      <v-icon title="Очікує завантаження на сервер">file_upload</v-icon>
      {{ media.image.input.name }}
    </div> -->


    <div class="thumbnail">
      <v-card-media
        v-if="media.image && (media.image.inputPreview)"
        :src="media.image.inputPreview"
        :style="{ width: '170px' }"
        :height="96"></v-card-media>
      <image-thumbnail v-else :media="media" :width="170"></image-thumbnail>
    </div>

    <div class="media-content">
      <div class="media-title">
        <template v-if="media.image.ref">
          <v-icon>photo</v-icon> {{ media.image.ref }}
        </template>
        <template v-else>
          <v-icon>photo</v-icon>
          <v-icon title="Очікує завантаження на сервер">file_upload</v-icon>
          {{ media.image.input.name }}
        </template>
      </div>

      <div class="media-comment-wrapper">
        <label>Коментар</label>
        <textarea-autosize
          v-model="media.image.comment"


        ></textarea-autosize>
      </div>
    </div>

  </div>
</template>

<script>

import Vue from 'vue';
import { getImageFilePreview } from '@/services/ImagePreview';

import ImageThumbnail from '@/components/ImageThumbnail';

export default {
  name: 'PostFormMediaImageItem',
  components: {
    ImageThumbnail,
  },
  props: {
    media: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    if (this.media.image.input) {
      getImageFilePreview(this.media.image.input)
        .then((previewDataUri) => {
          Vue.set(this.media.image, 'inputPreview', previewDataUri);
        });
    }
  },
};

</script>

<style scoped>

.post-form-media-image-item {
  display: flex;
  flex-direction: row;
}

.thumbnail {
  position: relative;
  margin-right: 10px;
}

.media-content {
  flex: 1;
  margin-left: 10px;
}

.media-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.media-comment-wrapper label {
  font-size: 14px;
}

.media-comment-wrapper textarea {
  border: solid 1px #ddd;
  padding: 5px;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/PostFormMediaImageItem.vue